import { AccountManagementEvent } from '@/services/analytics/events/';
import {
  AccountManagementAnalytics,
  AnalyticsEventType,
  InteractionTrackingType,
  RegistrationType
} from '@/services/analytics/platforms/adobe-analytics/models';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { AdobeBaseEvent } from './adobe-base-event';
import { ProductListItem } from '../classes';

export class AdobeAccountManagementEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LinkClicked;
  account = { ...this.account, loginType: RegistrationType.OrderWeb, accountInteraction: { value: 1 }, registrationType: RegistrationType.OrderWeb } as AccountManagementAnalytics;

  constructor(event: AccountManagementEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if (event.meals) {
      this.productListItems = ProductListItem.getProductListItems(event.meals, store, services.order.isDelivery());
    }

    this.account.interactionName = event.eventType;
    this.web.webInteraction = {
      name: event.eventType,
      linkClicks: { value: 1 },
      type: 'other',
    }
    this.account.availablePoints = services.reward.getPointsBalance() ?? 0;

    if (event.rewardTitle) {
      this.account.rewardTitle = event.rewardTitle;
    }

    switch (event.eventType) {
      case 'logins':
        this.account.logins = { value: 1 };
        this.web.webInteraction.linkModuleName = 'Account|Sign In';
        break;
      case 'registrationStart':
        this.account.registrationStart = { value: 1 };
        this.account.registrationType = RegistrationType.OrderWeb;
        this.web.webInteraction.linkModuleName = 'Account|Create Account Modal|Create Account Start';
        break;
      case 'registrationComplete':
        this.account.logins = { value: 1 };
        this.account.registrationComplete = { value: 1 };
        this.account.registrationType = RegistrationType.OrderWeb;
        this.web.webInteraction.linkModuleName = 'Account|Create Account Modal|Create Account Complete';
        break;
      case 'requestRewardsStart':
        this.account.requestRewardsStart = { value: 1 };
        this.web.webInteraction.linkModuleName = 'Account|Create Account Modal|Create Account Complete';
        break;
      case 'requestRewardsComplete':
        this.account.requestRewardsComplete = { value: 1 };
        this.web.webInteraction.linkModuleName = 'Account|Create Account Modal|Create Account Complete';
        break;
      case 'recentOrdersViewed':
        this.account.recentOrdersViewed = { value: 1 };
        this.web.webInteraction.linkModuleName = 'Recents and Favorites Page|Recents Toggle|Recents';
        break;
      case 'favoritedOrdersViewed':
        this.account.favoriteOrdersViewed = { value: 1 };
        this.web.webInteraction.linkModuleName = 'Recents and Favorites Page|Favorites Toggle|Favorites';
        break;
      case 'orderFavorited':
        this.account.orderFavorited = { value: 1 };
        this.web.webInteraction.linkModuleName = 'Recents and Favorites Page|Favorite Toggle|Order Favorited';
        break;
      case 'cartAddFavoritedMeal':
        this.account.cartAddFavoritedMeal = { value: 1 };
        this.account.orderFavorited = { value: 1 };
        this.web.webInteraction.linkModuleName = 'Recents and Favorites Page|Favorite Order Card|Add To Bag';
        this.account.favoritedMeal = true;
        break;
      case 'qrScanned':
        this.account.qrScanned = { value: 1 };
        this.web.webInteraction.linkModuleName = 'QR Modal|QR Scanned';
        break;
      case InteractionTrackingType.RewardsViewed:
        this.account.rewardsViewed = { value: 1 };
        this.web.webInteraction.linkModuleName = `Rewards Page|View Reward|${event.rewardTitle ?? ''}`;
        break;
      case 'rewardsAddedToWallet':
        this.event = AnalyticsEventType.Reward;
        this.account.rewardsAddedToWallet = { value: 1 };
        this.web.webPageDetails.name = 'account:rewards:home';
        this.web.webPageDetails.siteSection = 'account';
        this.web.webPageDetails.layer = 'favorited-reward-layer';
        break;
      case InteractionTrackingType.RewardsFavorited:
        this.event = AnalyticsEventType.Reward;
        this.account.rewardsFavorited = { value: 1 };
        this.web.webInteraction.linkModuleName = `Rewards Page|Reward Favorited|${event.rewardTitle ?? ''}`;
        break;
      case 'rewardsScanned':
        this.event = AnalyticsEventType.Reward;
        this.account.rewardsScanned = { value: 1 };
        break;
      case InteractionTrackingType.RewardsAddedToBag:
        this.event = AnalyticsEventType.Reward;
        this.account.rewardsAddedToBag = { value: 1 };
        this.web.webInteraction.linkModuleName = `Rewards Page|Add Reward To Bag|${event.rewardTitle}`;
        this.web.webPageDetails.name = 'order:cart';
        this.web.webPageDetails.siteSection = event.siteSection;
        break;
      case InteractionTrackingType.SelectNutritionPreferences:
        this.account.nutritionPrefs = { value: 1 };
        this.web.webInteraction.linkModuleName = event.eventType;
        break;
      case InteractionTrackingType.EditInfo:
      case InteractionTrackingType.UpdatePassword:
      case InteractionTrackingType.LeaveRewards:
      case InteractionTrackingType.JoinRewards:
      case InteractionTrackingType.ToggleEmailOn:
      case InteractionTrackingType.ToggleEmailOff:
      case InteractionTrackingType.ToggleTextOn:
      case InteractionTrackingType.ToggleTextOff:
      case InteractionTrackingType.AccessiblePickupToggleOn:
      case InteractionTrackingType.AccessiblePickupToggleOff:
        this.web.webInteraction.linkModuleName = event.eventType;
        break;
    }
  }
}
